import { render, staticRenderFns } from "./AddSubAsset.vue?vue&type=template&id=20342c22"
import script from "./AddSubAsset.vue?vue&type=script&lang=ts"
export * from "./AddSubAsset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports